<template lang="pug">
.panner(
  ref="container"
  :style="style"
  @mousedown="onMouseDown"
  @mouseup="onMouseUp"
  @mousemove="onMouseMove"
)
  slot
</template>

<script>
export default {
  name: 'Panner',

  data () {
    return {
      dragging: false,
      x: 0,
      y: 0
    }
  },

  computed: {
    style () {
      return {
        cursor: this.dragging ? 'grabbing' : 'grab'
      }
    }

    // xScrollable() {
    //   if (!this.$refs.container) return false
    //   const maxWidth = this.$refs.container.offsetWidth
    //   const content = this.$refs.container.children[0]
    //   if (content) {
    //     const width = content.offsetWidth
    //     if (width > maxWidth) return true
    //   }
    //   return false
    // }
  },

  methods: {
    onMouseDown (e) {
      const target = e.target
      if (!['TD'].includes(target.tagName)) return
      this.dragging = true
      this.x = e.screenX
      this.y = e.screenY
      this.scrollLeft = this.$refs.container.scrollLeft
      this.scrollTop = this.$refs.container.scrollTop
    },

    onMouseUp () {
      this.dragging = false
    },

    onMouseMove (e) {
      if (!this.dragging || !e.which) return
      e.preventDefault()
      const deltaX = e.screenX - this.x
      this.$refs.container.scrollLeft = this.scrollLeft - deltaX
      // const deltaY = e.screenY - this.y
      // this.$refs.container.scrollTop = this.scrollTop - deltaY
    }
  }
}
</script>

<style lang="scss" scoped>
.panner {
  width: 100%;
  overflow-y: hidden;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    width: 1px;
    height: 1px;
  }
  &::-webkit-scrollbar-thumb {
    background: #555;
  }
  ::v-deep > * {
    min-width: 100%;
    max-width: unset;
    display: block;
    width: max-content;
  }
  ::v-deep > table {
    display: inline-table;
  }
}
</style>
